enum QueryParamKeys {
  NumberOfMonths = 'numberOfMonths',
  Type = 'type',
  BranchId = 'branchId',
  SPVMarketingId = 'spvMarketingId',
  AREMarketingId = 'areMarketingId',
  AgentMarketingId = 'agentMarketingId',
  ReportId = 'reportId',
  ActiveTab = 'activeTab',
  From = 'from',
  Month = 'month',
  StartDate = 'startDate',
  EndDate = 'endDate',
  OpenSetTarget = 'openSetTarget',
  Show = 'show',
  Category = 'category',
  WeekRangeOffset = 'weekRangeOffset',
  Page = 'page',
  City = 'city',
}

export default QueryParamKeys;
